import _defineProperty from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ONE_MINUTE, generateUUID, createValueHistory, elapsed, combine } from '@datadog/browser-core';
import { trackEventCounts } from './trackEventCounts';
export var EVENT_CONTEXT_TIME_OUT_DELAY = 5 * ONE_MINUTE; // arbitrary
export function startEventTracker(lifeCycle) {
  // Used by actions to associate events with actions.
  var history = createValueHistory({
    expireDelay: EVENT_CONTEXT_TIME_OUT_DELAY
  });
  // Used by manual actions and resources that use named keys to match the start and stop calls.
  var keyedEvents = new Map();
  function cleanUpEvent(event) {
    var _a;
    keyedEvents["delete"](event.key);
    (_a = event.eventCounts) === null || _a === void 0 ? void 0 : _a.stop();
  }
  function discardAll() {
    keyedEvents.forEach(function (event) {
      cleanUpEvent(event);
    });
    history.reset();
  }
  var sessionRenewalSubscription = lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, discardAll);
  function start(key, startClocks, data, options) {
    var id = generateUUID();
    var historyEntry = history.add(id, startClocks.relative);
    var existing = keyedEvents.get(key);
    if (existing) {
      cleanUpEvent(existing);
    }
    var eventCounts = (options === null || options === void 0 ? void 0 : options.isChildEvent) ? trackEventCounts({
      lifeCycle: lifeCycle,
      isChildEvent: options.isChildEvent(id)
    }) : undefined;
    var trackedEventData = {
      id: id,
      key: key,
      startClocks: startClocks,
      data: data,
      historyEntry: historyEntry,
      eventCounts: eventCounts
    };
    keyedEvents.set(key, trackedEventData);
    return trackedEventData;
  }
  function stop(key, stopClocks, extraData) {
    var _a;
    var event = keyedEvents.get(key);
    if (!event) {
      return undefined;
    }
    var finalData = extraData ? combine(event.data, extraData) : event.data;
    event.historyEntry.close(stopClocks.relative);
    var duration = elapsed(event.startClocks.timeStamp, stopClocks.timeStamp);
    var counts = (_a = event.eventCounts) === null || _a === void 0 ? void 0 : _a.eventCounts;
    cleanUpEvent(event);
    return _objectSpread(_objectSpread({}, finalData), {}, {
      id: event.id,
      startClocks: event.startClocks,
      duration: duration,
      counts: counts
    });
  }
  function discard(key) {
    var _a;
    var event = keyedEvents.get(key);
    if (!event) {
      return undefined;
    }
    var counts = (_a = event.eventCounts) === null || _a === void 0 ? void 0 : _a.eventCounts;
    cleanUpEvent(event);
    event.historyEntry.remove();
    return _objectSpread(_objectSpread({}, event.data), {}, {
      id: event.id,
      startClocks: event.startClocks,
      counts: counts
    });
  }
  function findId(startTime) {
    return history.findAll(startTime);
  }
  function getCounts(key) {
    var _a, _b;
    return (_b = (_a = keyedEvents.get(key)) === null || _a === void 0 ? void 0 : _a.eventCounts) === null || _b === void 0 ? void 0 : _b.eventCounts;
  }
  function stopTracker() {
    sessionRenewalSubscription.unsubscribe();
    discardAll();
    history.stop();
  }
  return {
    start: start,
    stop: stop,
    discard: discard,
    getCounts: getCounts,
    findId: findId,
    stopAll: stopTracker
  };
}